// src/App.js
import React, { useEffect } from 'react'; // Import useEffect
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom'; // Import useLocation
import Navbar from './components/Navbar/navbar';
import Home from './pages/Home';
import './App.css';
/*
import Footer from './components/Footer/Footer';
import ClientsSection from './pages/ClientsSection';
import ProductShowcase from './components/ProductShowcase/ProductShowcase';
import QualityCompliance from './components/QualityComp/QualityComp';
import ManufacturingFacilities from './components/ManuFaci/ManuFaci';
import ProcessFlow from './components/ProcessFlow/ProcessFlow'; */
import whatsappImg from './assets/whatsapp.png';
import FullAbout from './components/FullAbout/FullAbout';
import Capabilities from './components/Capabilites/Capabilities';
import Infrastructure from './components/Infrastructure/Infrastructure';
import FullProduct from './components/FullProduct/FullProduct';
import ContactUs from './pages/ContactUs';
import FAQ from './components/FullAbout/FAQ/FAQ';

// Updated MainLandingPage Component
const MainLandingPage = () => {
  const location = useLocation();

  // This Effect runs every time the page loads or the location changes
  useEffect(() => {
    // Check if we passed a "scrollTo" state from the Navbar
    if (location.state && location.state.scrollTo) {
      const sectionId = location.state.scrollTo;
      const element = document.getElementById(sectionId);

      // If the element is found, scroll to it
      if (element) {
        // Small timeout ensures the DOM is fully painted before scrolling
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, [location]);

  return (
    <>
      <Navbar />
      <section id="home"><Home /></section>


      <a href="https://wa.me/9840314831" className="whatsapp-float" target="_blank" rel="noopener noreferrer">
        <img src={whatsappImg} alt="WhatsApp Chat" style={{ width: "60px", height: "60px" }} />
      </a>
    </>
  );
};

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<MainLandingPage />} />
          <Route path="/about-full" element={<FullAbout />} />
          <Route path="/capabilities" element={<Capabilities />} />
          <Route path="/infrastructure" element={<Infrastructure />} />
          <Route path="/product-full" element={<FullProduct />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/faq" element={<FAQ />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;